import { BadgeCheck, Clock, CheckCircle2, XCircle, AlertCircle } from 'lucide-react';

interface InvoiceStatusBadgeProps {
    status: 'draft' | 'issued' | 'partially_paid' | 'paid' | 'void' | 'refunded' | 'written_off';
}

export default function InvoiceStatusBadge({ status }: InvoiceStatusBadgeProps) {
    const config: Record<string, { icon: typeof Clock; label: string }> = {
        draft: {
            icon: Clock,
            label: 'Draft'
        },
        issued: {
            icon: AlertCircle,
            label: 'Issued'
        },
        partially_paid: {
            icon: Clock,
            label: 'Partial'
        },
        paid: {
            icon: CheckCircle2,
            label: 'Paid'
        },
        void: {
            icon: XCircle,
            label: 'Void'
        },
        refunded: {
            icon: BadgeCheck,
            label: 'Refunded'
        },
        written_off: {
            icon: AlertCircle,
            label: 'Written Off'
        },
    };

    const style = config[status] || config.draft;
    const Icon = style.icon;

    // Colour comes from .fd-status[data-status] (styles/components.css); this
    // map only supplies the icon and label. An unknown status shows as draft.
    return (
        <span className="fd-status" data-status={config[status] ? status : 'draft'}>
            <Icon aria-hidden="true" />
            {style.label}
        </span>
    );
}
